import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";

const Panel = ({ title, action, children }) => (
  <Paper variant="outlined" sx={{ borderRadius: "14px", p: "20px 22px", height: "100%" }}>
    {title && (
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography sx={{ fontWeight: 700, fontSize: 15 }}>{title}</Typography>
        {action && (
          <Typography component="a" href="#" sx={{ fontSize: 12, fontWeight: 600, color: "#4b1f6b", textDecoration: "none" }}>
            {action}
          </Typography>
        )}
      </Stack>
    )}
    <Box>{children}</Box>
  </Paper>
);

export default Panel;
